var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleCheckCircle = function SvgDoubleCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.385 6.65l1.297 1.297-6.59 6.591L2 10.72l1.251-1.341 2.796 2.609zM16.385 7l1.297 1.297-6.59 6.59-2.082-1.942 1.298-1.298.74.691L16.384 7z"
  }))));
};
export default SvgDoubleCheckCircle;